<div class="group-management-wrapper">

    <!-- Create New Product Group -->
    <div class="create-group-section">
      <h2>Create Product Group</h2>
  
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Group Name</mat-label>
        <input matInput [(ngModel)]="newGroup.name" required>
      </mat-form-field>
  
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Description</mat-label>
        <textarea matInput [(ngModel)]="newGroup.description"></textarea>
      </mat-form-field>
  
      <button mat-raised-button color="primary" (click)="createGroup()" [disabled]="!newGroup.name">
        + Create Group
      </button>
    </div>
  
    <hr class="divider" />
  
    <!-- List and Manage Product Groups -->
    <div class="group-list-section">
      <h2>Existing Product Groups</h2>
  
      <table mat-table [dataSource]="productGroups" class="mat-elevation-z8 full-width">
  
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef> Name </th>
          <td mat-cell *matCellDef="let group">
            <ng-container *ngIf="editingGroup && editingGroup.id === group.id; else staticName">
              <mat-form-field class="full-width" appearance="outline">
                <input matInput [(ngModel)]="editingGroup.name" placeholder="Group Name" required>
              </mat-form-field>
            </ng-container>
            <ng-template #staticName>
              {{ group.name }}
            </ng-template>
          </td>
        </ng-container>
  
        <!-- Description Column -->
        <ng-container matColumnDef="description">
          <th mat-header-cell *matHeaderCellDef> Description </th>
          <td mat-cell *matCellDef="let group">
            <ng-container *ngIf="editingGroup && editingGroup.id === group.id; else staticDescription">
              <mat-form-field class="full-width" appearance="outline">
                <textarea matInput [(ngModel)]="editingGroup.description" placeholder="Description"></textarea>
              </mat-form-field>
            </ng-container>
            
            <ng-template #staticDescription>
              {{ group.description || '—' }}
            </ng-template>
          </td>
        </ng-container>
  
        <!-- Actions Column -->
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef> Actions </th>
          <td mat-cell *matCellDef="let group">
            <ng-container *ngIf="editingGroup && editingGroup.id === group.id; else actionButtons">
              <button mat-button color="primary" (click)="updateGroup()">Save</button>
              <button mat-button (click)="cancelEdit()">Cancel</button>
            </ng-container>
            <ng-template #actionButtons>
              <button mat-icon-button color="primary" (click)="editGroup(group)">
                <mat-icon>edit</mat-icon>
              </button>
              <button mat-icon-button color="warn" (click)="deleteGroup(group.id)">
                <mat-icon>delete</mat-icon>
              </button>
            </ng-template>
          </td>
        </ng-container>
  
        <tr mat-header-row *matHeaderRowDef="['name', 'description', 'actions']"></tr>
        <tr mat-row *matRowDef="let row; columns: ['name', 'description', 'actions'];"></tr>
      </table>
  
<!-- Assign Products to Group -->
<div class="assign-products-section" *ngIf="selectedGroupId">
    <h3>Assign Products to Group</h3>
  
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Select Products</mat-label>
      <mat-select [(ngModel)]="selectedProductIds" multiple>
        <mat-option *ngFor="let p of products" [value]="p.product_id">{{ p.name }}</mat-option>
      </mat-select>
    </mat-form-field>
  
    <button mat-raised-button color="primary" (click)="assignProductsToGroup()"
            [disabled]="selectedProductIds.length === 0">Assign Products</button>
  </div>
  
  <!-- View Products in Group -->
  <div class="group-products-section" *ngIf="groupProducts.length > 0">
    <h3>Products in Selected Group</h3>
    <table mat-table [dataSource]="groupProducts" class="mat-elevation-z8 full-width">
      <ng-container matColumnDef="product_id">
        <th mat-header-cell *matHeaderCellDef> Product ID </th>
        <td mat-cell *matCellDef="let row"> {{ row.product_id }} </td>
      </ng-container>
  
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef> Name </th>
        <td mat-cell *matCellDef="let row"> {{ row.name }} </td>
      </ng-container>
  
      <tr mat-header-row *matHeaderRowDef="['product_id', 'name']"></tr>
      <tr mat-row *matRowDef="let row; columns: ['product_id', 'name'];"></tr>
    </table>
  </div>
  

      <div *ngIf="productGroups.length === 0" class="no-results-message">
        No product groups found.
      </div>
    </div>
  </div>
  